// Builds the value of a `data-mdlfy-cms` attribute: `<table>:<row id>:<column>`.
// Put it on the element whose text is exactly that one database value, so the
// text can be edited straight from the preview.
export const cms = (table: string, id: string, column: string): string => `${table}:${id}:${column}`
